/* eslint-disable react/no-array-index-key */
import Skeleton from 'components/Skeleton';

import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import { withColorScheme } from 'redesignedComponents/decorators/withColorScheme';
import useStyles, { useTabImageStyles, useTabStyles } from './styles';

const UseCasesSkeleton = () => {
  const colorScheme = useColorScheme();
  const styles = useStyles({ colorScheme });
  const tabStyles = useTabStyles({ colorScheme });
  const tabImageStyles = useTabImageStyles({ colorScheme });

  return (
    <div className={styles.root}>
      <Skeleton className={tabStyles.skeletonTitle} />
      <div className={styles.toggleButtonsSkeleton}>
        <Skeleton />
      </div>
      <Skeleton className={styles.skeletonDescription} />
      <div className={tabStyles.skeletonUseCaseTabList}>
        <div className={tabStyles.skeletonUseCaseTab}>
          {[...Array(3)].map((_, index) => (
            <div key={index} className={styles.skeletonFlex}>
              <Skeleton className={tabImageStyles.skeletonImage} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default withColorScheme<unknown>(UseCasesSkeleton);
